'use client';

import { createContext, useContext, useReducer } from 'react';

const AppContext = createContext();

const initialState = {
    user: null,
    menu: [],
    tipNotification: { show: false, link: '', type: '', pendingLinks: [] },
    aiWaiting: { show: false, module: '' },
    iframe: false,
    errorReport: { show: false, error: null, timestamp: null, url: null },
    bootstrap: false,
};

const appReducer = (state, action) => {
    switch (action.type) {
        case 'initialize':
            return {
                ...state,
                user: action.payload.user,
                menu: action.payload.menu,
            };
        case 'logout':
            return { ...initialState };
        case 'user':
            return {
                ...state,
                // Si payload est null ou undefined, on remplace complètement
                // Sinon on merge avec l'existant (pour les mises à jour partielles)
                user: action.payload === null || action.payload === undefined
                    ? action.payload
                    : { ...state.user, ...action.payload },
            };
        case 'menu':
            return {
                ...state,
                menu: action.payload,
            };
        case 'tipNotification':
            return {
                ...state,
                tipNotification: action.payload,
            };
        case 'tipNotification:push':
            return {
                ...state,
                tipNotification: {
                    ...state.tipNotification,
                    show: true,
                    link: action.payload,
                    pendingLinks: [...(state.tipNotification.pendingLinks || []), action.payload],
                },
            };
        case 'aiWaiting':
            return {
                ...state,
                aiWaiting: action.payload,
            };
        case 'iframe':
            return {
                ...state,
                iframe: action.payload,
            };
        case 'errorReport':
            return {
                ...state,
                errorReport: action.payload,
            };
        default:
            return state;
    }
};

export const AppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = (state) => {
    const context = useContext(AppContext);
    const { state: appState, dispatch } = context;
    return [
        appState[state],
        (value) => dispatch({ type: state, payload: value }),
    ];
};

export const useAddTipNotification = () => {
    const { dispatch } = useContext(AppContext);
    return (link) => dispatch({ type: 'tipNotification:push', payload: link });
};

